export const tr = {
    'switch-to-old-interface': 'Hata tekrarlanıyorsa eski arayüze dönebilirsiniz',
    'switch-to-old-interface-link': 'Eski arayüze geri dönmek istiyorum'
};
